<template>
  <div class="component-faq" :class="{ 'component-faq--full': full }">
    <div class="component-faq__pattern">
      <img src="~/assets/components/faq/pattern.svg" alt="" />
    </div>
    <div class="component-faq__list">
      <FaqAccordion
        v-for="faq in faqs"
        :key="faq.id"
        :title="faq.question"
        :text="faq.answer"
        border-bottom
      />
    </div>
  </div>
</template>

<script>
import FaqAccordion from '@/components/faq/FaqAccordion'

export default {
  name: 'Faq',
  components: { FaqAccordion },
  props: {
    full: {
      type: Boolean,
      default: false
    },
    faqs: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss">
.component-faq {
  display: flex;

  &--full {
    .component-faq__pattern {
      display: none;
    }
  }

  &__pattern {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: rem(80px);
    width: 25%;
    flex: 0 0 25%;

    @include media-breakpoint-only(md) {
      width: auto;
      flex: 0 0 auto;
      padding-right: rem(40px);
    }

    @include media-breakpoint-down(sm) {
      display: none;
    }
  }

  &__list {
    flex: 1 1 auto;
  }
}
</style>
